stzh-cspace {
  @include host;
  color: inherit;
  font-weight: inherit;
  font-family: inherit;
  letter-spacing: inherit;

  // Remove edge margin

  &[has-hidden-first-margin] > .stzh-cspace {
    & > :first-child {
      margin-top: 0 !important;
    }

    & > .section:first-child > *:first-child {
      margin-top: 0 !important;
    }
  }

  &[has-hidden-last-margin] > .stzh-cspace {
    & > :last-child {
      margin-bottom: 0 !important;
    }

    & > .section:last-child > *:last-child {
      margin-bottom: 0 !important;
    }
  }
}

stzh-cspace > .stzh-cspace {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  // display: flex;
  // flex-direction: column;
  // align-items: flex-start;

  & > .section > h1,
  & > h1,
  & > .section > :where(stzh-heading[level="1"]),
  & > :where(stzh-heading[level="1"]) {
    @include spaceCurve('margin-top', 'large');
    @include spaceCurve('margin-bottom', 'medium');
  }

  & > .section > h2,
  & > h2,
  & > .section > :where(stzh-heading[level="2"]),
  & > :where(stzh-heading[level="2"]) {
    @include spaceCurve('margin-top', 'regular');
    @include spaceCurve('margin-bottom', 'tiny');
  }

  & > .section > h3,
  & > h3,
  & > .section > :where(stzh-heading[level="3"]),
  & > :where(stzh-heading[level="3"]) {
    @include spaceCurve('margin-top', 'small');
    @include spaceCurve('margin-bottom', 'tiny');
  }

  & > .section > h4,
  & > h4,
  & > .section > :where(stzh-heading[level="4"]),
  & > :where(stzh-heading[level="4"]) {
    @include spaceCurve('margin-top', 'small');
    @include spaceCurve('margin-bottom', 'tiny');
  }

  & > .section > p,
  & > p,
  & > .section > stzh-text,
  & > stzh-text,
  & > .section > ul,
  & > ul,
  & > .section > ol,
  & > ol,
  & > .section > dl,
  & > dl,
  & > .section > stzh-list,
  & > stzh-list {
    @include spaceCurve('margin-bottom', 'small');
    margin-top: 0;
  }

  & > .section > :where(stzh-text[curve="hero"]),
  & > :where(stzh-text[curve="hero"]),
  & > .section > :where(stzh-heading[curve="hero"]),
  & > :where(stzh-heading[curve="hero"]) {
    @include spaceCurve('margin-bottom', 'medium');
    margin-top: 0;
  }

  & > .section > :where(stzh-text[curve="h1"]),
  & > :where(stzh-text[curve="h1"]),
  & > .section > :where(stzh-heading[curve="h1"]),
  & > :where(stzh-heading[curve="h1"]) {
    @include spaceCurve('margin-top', 'large');
    @include spaceCurve('margin-bottom', 'medium');
  }

  & > .section > :where(stzh-text[curve="h2"]),
  & > :where(stzh-text[curve="h2"]),
  & > .section > :where(stzh-heading[curve="h2"]),
  & > :where(stzh-heading[curve="h2"]) {
    @include spaceCurve('margin-top', 'large');
    @include spaceCurve('margin-bottom', 'small');
  }

  & > .section > :where(stzh-text[curve="h3"]),
  & > :where(stzh-text[curve="h3"]),
  & > .section > :where(stzh-heading[curve="h3"]),
  & > :where(stzh-heading[curve="h3"]) {
    @include spaceCurve('margin-top', 'regular');
    @include spaceCurve('margin-bottom', 'tiny');
  }

  & > .section > :where(stzh-text[curve="h4"]),
  & > :where(stzh-text[curve="h4"]),
  & > .section > :where(stzh-heading[curve="h4"]),
  & > :where(stzh-heading[curve="h4"]) {
    @include spaceCurve('margin-top', 'regular');
    @include spaceCurve('margin-bottom', 'tiny');
  }

  & > .section > :where(stzh-text[curve="p1"]),
  & > :where(stzh-text[curve="p1"]),
  & > .section > :where(stzh-heading[curve="p1"]),
  & > :where(stzh-heading[curve="p1"]) {
    @include spaceCurve('margin-bottom', 'regular');
    margin-top: 0;
  }

  & > .section > :where(stzh-text[curve="p2"]),
  & > :where(stzh-text[curve="p2"]),
  & > .section > :where(stzh-heading[curve="p2"]),
  & > :where(stzh-heading[curve="p2"]) {
    @include spaceCurve('margin-top', 'small');
    @include spaceCurve('margin-bottom', 'small');
  }

  & > .section > stzh-input, // DONE
  & > stzh-input, // DONE
  & > .section > stzh-datepicker, // DONE
  & > stzh-datepicker, // DONE
  & > .section > stzh-daterange, // DONE
  & > stzh-daterange, // DONE
  & > .section > stzh-dropdown, // DONE
  & > stzh-dropdown, // DONE
  & > .section > stzh-upload, // DONE
  & > stzh-upload, // DONE
  & > .section > stzh-checkbox, // DONE
  & > stzh-checkbox, // DONE
  & > .section > stzh-checkboxgroup, // DONE
  & > stzh-checkboxgroup, // DONE
  & > .section > stzh-radio, // DONE
  & > stzh-radio, // DONE
  & > .section > stzh-radiogroup, // DONE
  & > stzh-radiogroup { // DONE
    @include spaceCurve('margin-bottom', 'tiny');
  }

  & > .section > stzh-chipgroup, // DONE
  & > stzh-chipgroup, // DONE
  & > .section > stzh-chipselect, // DONE
  & > stzh-chipselect { // DONE
    margin-bottom: space('xlarge');
  }

  & > .section > stzh-http-error, // DONE
  & > stzh-http-error { // DONE
    @include spaceCurve('margin-top', 'big');
  }

  & > .section > stzh-message, // DONE
  & > stzh-message { // DONE
    @include spaceCurve('margin-bottom', 'regular');
  }

  & > .section > stzh-cardlist, // DONE
  & > stzh-cardlist, // DONE
  & > .section > stzh-contact, // DONE
  & > stzh-contact, // DONE
  & > .section > stzh-accordion, // DONE
  & > stzh-accordion, // DONE
  & > .section > stzh-anchornav, // DONE
  & > stzh-anchornav, // DONE
  & > .section > stzh-audio, // DONE
  & > stzh-audio, // DONE
  & > .section > stzh-microsite-teaserlist,
  & > stzh-microsite-teaserlist,
  & > .section > stzh-gallery, // DONE
  & > stzh-gallery, // DONE
  & > .section > stzh-panorama,
  & > stzh-panorama,
  & > .section > stzh-chart,
  & > stzh-chart,
  & > .section > stzh-sitemap,
  & > stzh-sitemap,
  & > .section > stzh-hr,
  & > stzh-hr,
  & > .section > stzh-archivelist,
  & > stzh-archivelist,
  & > .section > stzh-figure, // DONE
  & > stzh-figure, // DONE
  & > stzh-iframe, // DONE
  & > .section > stzh-youtube, // DONE
  & > stzh-youtube, // DONE
  & > .section > stzh-vbz-ticker,
  & > stzh-vbz-ticker {
    @include spaceCurve('margin-bottom', 'large');
  }

  & > .section > stzh-ratio, // DONE
  & > stzh-ratio, // DONE
  & > .section > stzh-button, // DONE
  & > stzh-button, // DONE
  & > .section > stzh-space, // DONE
  & > stzh-space, // DONE
  & > .section > stzh-row, // DONE
  & > stzh-row, // DONE
  & > .section > stzh-eventinfo, // DONE
  & > stzh-eventinfo, // DONE
  & > .section > stzh-eventdata, // DONE
  & > stzh-eventdata, // DONE
  & > .section > stzh-datalist, // DONE
  & > stzh-datalist, // DONE
  & > .section > stzh-textandimage, // DONE
  & > stzh-textandimage { // DONE
    @include spaceCurve('margin-bottom', 'medium');
  }

  & > .section > stzh-section[variant="highlight"], // DONE
  & > stzh-section[variant="highlight"] { // DONE
    @include spaceCurve('margin-top', 'regular');
    @include spaceCurve('margin-bottom', 'regular');
  }

  & > .section > stzh-section[variant="contextbox"], // DONE
  & > stzh-section[variant="contextbox"] { // DONE
    @include spaceCurve('margin-top', 'regular');
    @include spaceCurve('margin-bottom', 'regular');
  }

  & > .section > stzh-section[variant="default"], // DONE
  & > stzh-section[variant="default"] { // DONE
    @include spaceCurve('margin-top', 'regular');
    @include spaceCurve('margin-bottom', 'regular');
  }

  & > .section > stzh-section[variant="greybox"], // DONE
  & > stzh-section[variant="default"] { // DONE
    @include spaceCurve('margin-top', 'regular');
    @include spaceCurve('margin-bottom', 'regular');
  }

  & > .section > stzh-section[variant="poimax"], // DONE
  & > stzh-section[variant="poimax"] { // DONE
    @include spaceCurve('margin-top', 'regular');
    margin-bottom: space('xsmall');
  }

  & > .section > stzh-pagetitle[background="default"], // DONE
  & > stzh-pagetitle[background="default"] { // DONE
    @include spaceCurve('margin-bottom', 'section-inner');
  }

  & > .section > stzh-richtext[has-hidden-last-margin], // DONE
  & > stzh-richtext[has-hidden-last-margin] { // DONE
    @include spaceCurve('margin-bottom', 'regular');
  }

  & > .section > stzh-cta, // DONE
  & > stzh-cta { // DONE
    @include spaceCurve('margin-top', 'small');
    @include spaceCurve('margin-bottom', 'large');
  }

  & > .section > stzh-olmap,
  & > stzh-olmap {
    @include spaceCurve('margin-top', 'medium');
    @include spaceCurve('margin-bottom', 'medium');
  }

  & > .section > stzh-breadcrumb, // DONE
  & > stzh-breadcrumb { // DONE
    @include spaceCurve('margin-top', 'medium');
    @include spaceCurve('margin-bottom', 'regular');
  }

  & > .section > stzh-card,
  & > stzh-card {
    @include spaceCurve('margin-bottom', 'regular');
  }

  & > .section > stzh-appointments,
  & > stzh-appointments {
    @include spaceCurve('margin-bottom', 'big');

    &[has-heading] {
      @include spaceCurve('margin-top', 'regular');
    }
  }

  & > .section > stzh-table, // DONE
  & > stzh-table, // DONE
  & > .section > stzh-datatable, // DONE
  & > stzh-datatable { // DONE
    @include spaceCurve('margin-top', 'regular');
    @include spaceCurve('margin-bottom', 'large');
  }

  & > .section > stzh-pagebottom,
  & > stzh-pagebottom {
    @include spaceCurve('margin-top', 'medium');
    @include spaceCurve('margin-bottom', 'medium');
  }

  & > .section > stzh-stepper,
  & > stzh-stepper {
    @include spaceCurve('margin-top', 'big');
  }

  & > .section > stzh-pagination, // DONE
  & > stzh-pagination { // DONE
    @include spaceCurve('margin-top', 'regular');
    @include spaceCurve('margin-bottom', 'large');
  }

  & > .section > stzh-actions, // DONE
  & > stzh-actions { // DONE
    @include spaceCurve('margin-top', 'small');
    @include spaceCurve('margin-bottom', 'big');
  }

  & > .section > stzh-saptcha, // DONE
  & > stzh-saptcha { // DONE
    @include spaceCurve('margin-bottom', 'medium');
  }

  & > .section > stzh-fieldset, // DONE
  & > stzh-fieldset { // DONE
    @include spaceCurve('margin-bottom', 'tiny');

    &[legend] {
      @include spaceCurve('margin-top', 'regular');
    }
  }

  // & > stzh-heading[level="4"] + stzh-datalist,
  // & > stzh-heading[curve="h4"] + stzh-datalist {
  //   margin-top: 0;
  // }

  /* Utility classes for applying spacing curves */

  @each $spaceCurve, $value in $spaceCurves {
    $defaultSize: map-get($value, 'size');
    $breakpointSizes: map-get($value, 'sizes');

    & > .section > .cspace-y-curve-#{$spaceCurve},
    & > .cspace-y-curve-#{$spaceCurve} {
      @include spaceCurve('margin-top', $spaceCurve);
      @include spaceCurve('margin-bottom', $spaceCurve);
    }

    & > .section > .cspace-t-curve-#{$spaceCurve},
    & > .cspace-t-curve-#{$spaceCurve} {
      @include spaceCurve('margin-top', $spaceCurve);
    }

    & > .section > .cspace-b-curve-#{$spaceCurve},
    & > .cspace-b-curve-#{$spaceCurve} {
      @include spaceCurve('margin-bottom', $spaceCurve);
    }
  }

  /* Utility classes for applying spacing values */

  @each $breakpoint, $size in $breakpoints {
    @each $space, $value in $spaceSizes {
      @if $breakpoint {
        & > .section > .#{$breakpoint}\:cspace-y-#{$space},
        & > .#{$breakpoint}\:cspace-y-#{$space} {
          margin-top: #{$value};
          margin-bottom: #{$value};
        }

        & > .section > .#{$breakpoint}\:cspace-t-#{$space},
        & > .#{$breakpoint}\:cspace-t-#{$space} {
          margin-top: #{$value};
        }

        & > .section > .#{$breakpoint}\:cspace-b-#{$space},
        & > .#{$breakpoint}\:cspace-b-#{$space} {
          margin-bottom: #{$value};
        }
      } @else {
        & > .section > .cspace-y-#{$space},
        & > .cspace-y-#{$space} {
          margin-top: #{$value};
          margin-bottom: #{$value};
        }

        & > .section > .cspace-t-#{$space},
        & > .cspace-t-#{$space} {
          margin-top: #{$value};
        }

        & > .section > .cspace-b-#{$space},
        & > .cspace-b-#{$space} {
          margin-bottom: #{$value};
        }
      }
    }
  }

  & > .section > .cspace-y-0,
  & > .cspace-y-0 {
    margin-top: 0;
    margin-bottom: 0;
  }

  & > .section > .cspace-t-0,
  & > .cspace-t-0 {
    margin-top: 0;
  }

  & > .section > .cspace-b-0,
  & > .cspace-b-0 {
    margin-bottom: 0;
  }

  @each $breakpoint, $size in $breakpoints {
    & > .section > .#{$breakpoint}\:cspace-y-0,
    & > .#{$breakpoint}\:cspace-y-0 {
      margin-top: 0;
      margin-bottom: 0;
    }

    & > .section > .#{$breakpoint}\:cspace-t-0,
    & > .#{$breakpoint}\:cspace-t-0 {
      margin-top: 0;
    }

    & > .section > .#{$breakpoint}\:cspace-b-0,
    & > .#{$breakpoint}\:cspace-b-0 {
      margin-bottom: 0;
    }
  }
}
